import { render, staticRenderFns } from "./CrearTarjetaAmarilla.vue?vue&type=template&id=a74a584c"
import script from "./CrearTarjetaAmarilla.vue?vue&type=script&lang=js"
export * from "./CrearTarjetaAmarilla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports